(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener("DOMContentLoaded", (event) => {
    const mobileSearchToggle = document.querySelector(".header-icon-search-mobile");
    if (mobileSearchToggle) {
      mobileSearchToggle.addEventListener("click", ()=>{
        const searchDetails = document.querySelector(".header__search details");
        if (!searchDetails) return;
        if(searchDetails.hasAttribute("open")){
          searchDetails.removeAttribute("open")
        }else{
          searchDetails.setAttribute("open","true")
          // Focus the input synchronously (within the user gesture) so iOS reliably opens the keyboard.
          const searchInput = searchDetails.querySelector('.search__input, input[type="search"]');
          if (searchInput) searchInput.focus();
        }
      })
    }
  });

  // Toggle search-open / menu-open classes for transparent header white-bg on homepage
  document.addEventListener('DOMContentLoaded', function() {
    var sectionHeader = document.querySelector('.section-header');
    if (!sectionHeader) return;

    // Desktop + mobile search: white bg when search details is open
    document.querySelectorAll('.header__search details').forEach(function(details) {
      details.addEventListener('toggle', function() {
        var anyOpen = Array.from(document.querySelectorAll('.header__search details')).some(function(d) { return d.open; });
        sectionHeader.classList.toggle('search-open', anyOpen);
      });
    });

    // Mobile drawer: white bg when hamburger drawer is open
    var drawerDetails = document.getElementById('Details-menu-drawer-container');
    if (drawerDetails) {
      drawerDetails.addEventListener('toggle', function() {
        sectionHeader.classList.toggle('menu-open', drawerDetails.open);
      });
    }
  });

  // Dynamic announcement bar offset for transparent header
  function updateAnnouncementOffset() {
    const bar = document.querySelector('.matat-announcement-bar');
    const offset = bar ? bar.offsetHeight : 0;
    document.documentElement.style.setProperty('--announcement-top', offset + 'px');
  }

  document.addEventListener('DOMContentLoaded', updateAnnouncementOffset);
  window.addEventListener('resize', updateAnnouncementOffset);

  } catch(e) { console.error(e); }
})();
})();
